import {
    Container,
    Typography,
    Box,
    Stack,
    Button
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../../helper/LangHelper";
import { getCurrentPeriodYear, getDatePeriodOptions } from "../../helper/DatePeriodHelper";

export default function TestHelper() {
    const { t } = useTranslation();
    const [value, setValue] = React.useState(1234);

    React.useEffect(() => {
        setValue(1234);
    }, []);

    let lang = getLang();

    // setValue(1234);


    //getCurrentPeriodYear

    const test_DatePeriodHelper = () => {
        const currentYear = getCurrentPeriodYear();
        console.debug("currentYear: ", currentYear);

        const datePeriodOptions = getDatePeriodOptions(5);   
        console.debug("datePeriodOptions: ", datePeriodOptions);

        const datePeriodOptions2 = getDatePeriodOptions(2, 1);   
        console.debug("datePeriodOptions2: ", datePeriodOptions2);
    }

    const testList = [
        // test_getSkillParticipantDataCallback,
        test_DatePeriodHelper
    ];

    return (
        <Container maxWidth="lg">
            <Stack direction="column">
                <Typography variant="h3">Test Helper</Typography>

                <Box display="flex" direction="column" gap={3} sx={{ flexWrap: 'wrap' }}>
                    {
                        testList.map((testFunc, index) => {
                            return (
                                <Button key={index} variant="outlined" color="primary"
                                    onClick={
                                        testFunc
                                    }>
                                    {testFunc.name}
                                </Button>
                            );
                        })
                    }
                </Box>
            </Stack>
        </Container>
    )
}
